import { extendTheme, type ThemeConfig } from "@chakra-ui/react";

const config: ThemeConfig = {
    initialColorMode: "dark",
    useSystemColorMode: false
};

// 3. extend the theme
const chakraTheme = extendTheme({
    config,
    colors: {
        gray: {
            700: "#313131"
        }
    }
});

export default chakraTheme;
